var map = {
	"./de_DE.json": 666,
	"./en_AU.json": 667,
	"./en_CA.json": 668,
	"./en_GB.json": 669,
	"./es_AR.json": 670,
	"./es_ES.json": 671,
	"./es_MX.json": 672,
	"./fr_CA.json": 673,
	"./fr_FR.json": 674,
	"./it_IT.json": 675,
	"./nl_NL.json": 676,
	"./pt_BR.json": 677,
	"./pt_PT.json": 678
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 665;